import { Pipe, PipeTransform } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { BillingResponse } from '@billing/entities/billing.payload';
import { BillingDocumentsPipe } from '@billing/pipes/billing-documents.pipe';
import { BillingPersonType } from '@booking/entities/billing-person-types';
import { BillingFacade } from '@billing/billing.facade';
import { isValidBilligByConfigModule } from '@billing/mappers/valid-billing.mapper';
import { BookingBillingDocumentRules } from '@app/entities/booking-documents';

@Pipe({
  name: 'billingCollection',
  standalone: false
})
export class BillingCollectionPipe implements PipeTransform {

  constructor(
    private facade: BillingFacade,
    private billingDocumentsPipe: BillingDocumentsPipe
  ) { }

  transform(collection: BillingResponse[]): Observable<BillingResponse[]> {
    return zip(
      this.facade.bookingType$,
      this.billingDocumentsPipe.transform(BillingPersonType.NATURAL_PERSON, null),
      this.billingDocumentsPipe.transform(BillingPersonType.JURIDICAL_PERSON, null)
    ).pipe(
      map(([bookingType, naturalDocuments, legalDocuments]) => {
        const allDocuments = [...naturalDocuments, ...legalDocuments];
        return {
          bookingType,
          documents: allDocuments.filter((documents, index, self) =>
            index === self.findIndex(item => (item.DOCUMENT_ID === documents.DOCUMENT_ID))
          ),
        };
      }),
      map(({ documents, bookingType }) => {
        const mapper = collection.filter(billing => {
          const documentId = billing?.billing_info?.configuration_document_id;
          const isValidByDocumentId = documents.some(_document => _document.DOCUMENT_ID === documentId);
          if (isValidByDocumentId) {
            const _document = documents.find(document => document.DOCUMENT_ID === documentId);
            const validations = _document?.VALIDATIONS?.DOCUMENT_BUSINESS_RULES_BY_MODULES &&
              _document.VALIDATIONS.DOCUMENT_BUSINESS_RULES_BY_MODULES[bookingType] ?
              _document.VALIDATIONS.DOCUMENT_BUSINESS_RULES_BY_MODULES[bookingType] :
              {} as BookingBillingDocumentRules;
            const country = billing?.billing_info?.address?.country_code;
            return isValidBilligByConfigModule(country, validations);
          } else return false;
        });
        return mapper;
      })
    );
  }
}
